import {enableProdMode} from '@angular/core';
import 'core-js/client/shim.min.js';
import 'zone.js';
import 'reflect-metadata/Reflect.js';
import './polyfills';
import moment from 'moment';
import 'moment-timezone';
import 'leaflet-draw';
import L from 'leaflet';
import 'leaflet.pattern';
import BeautifyMarkers from 'beautifymarker';
import 'leaflet.sync';
import 'leaflet-svg-shape-markers';
import Projection from 'proj4leaflet';
import proj4 from 'proj4';
import 'leaflet.markercluster';
import {environment} from './environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';

declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
}

// needed for leaflet draw to initialize.

const drawHack = (window as any).L.Draw;
const patternHack = (window as any).L.Pattern;
const markerHack = BeautifyMarkers;
const syncHack = (window as any).L.Sync;
const svgHack = (window as any).L.SvgMarkers;
const projectionHack = Projection;

if (environment.production) {
    enableProdMode();
}

(window as any).m = moment;
(window as any).L = L;
(moment as any).tz.setDefault((moment as any).tz.guess());

// https://github.com/ckan/ckanext-geoview/issues/51
proj4.defs['OGC:CRS84'] = proj4.defs['EPSG:4326'];

(window as any).elementHasEllipsis = (element: HTMLElement) => {
    return element.offsetWidth < element.scrollWidth;
};

// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((err) => console.error(err));

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
